export const ANALYZING_RESUME_MSG = 'Analyzing your Resume';

export const SUGGEST_INDUSTRY_LINK_MSG = `Don't see the industry you're looking for?`;

export const entityVersionCheckError =
    ' It looks like the record you are trying to update has already ' +
    'been modified. Please refresh the page and try again.';
